export default "__VITE_ASSET__Bmsjev3f__"